import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { CsStandardTabComponent } from 'src/app/shared/components/cs-standard-tab/cs-standard-tab.component';
import { LogoModule } from 'src/app/shared/components/logo/logo.module';
import { NormalCarouselModule } from 'src/app/shared/components/normal-carousel/normal-carousel.module';
import { ScrollbarModule } from 'src/app/shared/components/scrollbar/scrollbar.module';
import { UserAvatarComponent } from 'src/app/shared/components/user-avatar/user-avatar.component';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { H5TopMenuComponent } from './h5-top-menu.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    LogoModule,
    NormalCarouselModule,
    PipesModule,
    CSButtonComponent,
    UserAvatarComponent,
    ScrollbarModule,
    OverlayModule,
    CsStandardTabComponent,
  ],
  declarations: [H5TopMenuComponent],
  exports: [H5TopMenuComponent],
})
export class H5TopMenuModule {}
